import {
  CLEAR_EXPERTS_FOR_FORWARDING_DROPDOWN,
  HYDRATE_EXPERTS_FOR_FORWARDING_DROPDOWN,
  SET_SEARCH_PARAM_FOR_FORWARDING_DROPDOWN,
  SET_SELECTED_EXPERT_FORWARDING_DROPDOWN,
} from 'actions/types';
import { forwardingDropdownInitialState } from 'initialStaticState';

export default (state = forwardingDropdownInitialState, action) => {
  switch (action.type) {
    case CLEAR_EXPERTS_FOR_FORWARDING_DROPDOWN:
      return {
        ...forwardingDropdownInitialState,
        searchParam: state.searchParam,
      };

    case HYDRATE_EXPERTS_FOR_FORWARDING_DROPDOWN:
      return {
        ...state,
        all: {
          ...state.all,
          ...action.experts.reduce((acc, item) => {
            acc[item.id] = item;

            return acc;
          }, {}),
        },
        pagination: {
          ...state.pagination,
          idList: [...state.pagination.idList, ...action.experts.map((item) => item.id)],
          nextPage: state.pagination.nextPage + 1,
          full: action.experts.length !== state.pagination.loadLimit,
          cursor: action.cursor,
        },
      };

    case SET_SEARCH_PARAM_FOR_FORWARDING_DROPDOWN: {
      return {
        ...state,
        searchParam: action.searchParam,
        pagination: {
          ...state.pagination,
          nextPage: 0,
          idList: [],
          full: false,
          cursor: null,
        },
      };
    }

    case SET_SELECTED_EXPERT_FORWARDING_DROPDOWN: {
      return {
        ...state,
        selectedExpert: action.selectedExpert,
        pagination: {
          ...state.pagination,
          nextPage: 0,
          idList: [],
          full: false,
          cursor: null,
        },
      };
    }

    default:
      return state;
  }
};
